import { TipoActivoFijo } from "./tipo-activo-fijo";

export class ActivoFijo{
    public constructor(
        public codigo: String ="",
        public nombre:String = "",
        public ubicacion:String = "",
        public responsable:String = "",
        public fecha_compra: any = "",
        public fecha_uso: any = "",
        public precio: string = "",
        public valor_residual: string = "",
        public tipo_activo_id: String = "",
        public empresa_id:String = "",
        public usuario_id:String = null,
        public status: String = "",
        public tipoactivo =  new TipoActivoFijo(),
    ){}
}


// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/models/activo-fijo.ts